import React from 'react';
import PushSubscribeButton from '../pushSubscribeButton/PushSubscribeButton.jsx';
import './jgAlertsActivation.css';

const copyByContext = {
  localops: {
    eyebrow: 'JG LocalOps',
    title: 'Turn on LocalOps alerts',
    body: 'Get notified when nearby tasks, rides, and local offers are posted.',
    smallLine: 'This also enables important JG alerts on this device.',
  },
  connect: {
    eyebrow: 'Joe Galaxy',
    title: 'Turn on JG alerts',
    body: 'Get notified about messages, requests, LocalOps tasks, and important updates.',
    smallLine: 'You can turn this off anytime.',
  },
};

const getCopy = (context) => copyByContext[context] || copyByContext.connect;

const JGAlertsActivationSheet = ({
  context = 'connect',
  jwt,
  onClose,
  onStateChange,
  onSubscribed,
  open,
  status = {},
  vapidKey,
}) => {
  if (!open) return null;

  const copy = getCopy(context);
  const permission = status.permission || 'default';
  const subscribed = Boolean(status.subscribed);
  const unsupported = status.hydrated && status.supported === false;
  const denied = permission === 'denied';

  let title = copy.title;
  let body = copy.body;
  let smallLine = copy.smallLine;
  let showEnable = !subscribed && !unsupported && !denied;

  if (subscribed) {
    title = 'Alerts are on';
    body = 'You will get notified when important JG activity needs your attention.';
    smallLine = '';
    showEnable = false;
  } else if (denied) {
    title = 'Notifications are blocked';
    body =
      'Open your browser or phone settings to allow notifications for Joe Galaxy.';
    smallLine = '';
    showEnable = false;
  } else if (unsupported) {
    title = 'Alerts are not supported in this browser';
    body = 'You can still check Joe Galaxy or email for updates.';
    smallLine = '';
    showEnable = false;
  }

  const buttonCopy =
    context === 'localops'
      ? {
          enableLabel: 'Enable alerts',
          compactEnableLabel: 'Enable',
          subscribedText: 'LocalOps alerts are on.',
          helpText:
            'Get notified when nearby tasks, rides, and local offers are posted.',
          successMessage: 'LocalOps alerts are on.',
        }
      : {
          enableLabel: 'Enable alerts',
          compactEnableLabel: 'Enable',
          subscribedText: 'Alerts are on.',
          helpText:
            'Get notified about messages, requests, LocalOps tasks, and important updates.',
          successMessage: 'Alerts are on.',
        };

  return (
    <div className="jgAlertsSheetBackdrop" role="presentation">
      <div
        aria-labelledby="jg-alerts-title"
        aria-modal="true"
        className="jgAlertsSheet"
        role="dialog"
      >
        <button
          aria-label="Close alerts help"
          className="jgAlertsSheetClose"
          onClick={onClose}
          type="button"
        >
          x
        </button>
        <div className="jgAlertsSheetEyebrow">{copy.eyebrow}</div>
        <h2 id="jg-alerts-title">{title}</h2>
        <p>{body}</p>
        {smallLine ? <div className="jgAlertsSheetNote">{smallLine}</div> : null}
        {showEnable ? (
          <PushSubscribeButton
            className="jgAlertsSubscribe"
            copy={buttonCopy}
            jwt={jwt}
            onStateChange={onStateChange}
            onSubscribed={onSubscribed}
            product={context === 'localops' ? 'localops' : 'connect'}
            vapidKey={vapidKey}
          />
        ) : (
          <button
            className="jgAlertsPrimary"
            onClick={onClose}
            type="button"
          >
            Got it
          </button>
        )}
        {showEnable ? (
          <button
            className="jgAlertsSecondary"
            onClick={onClose}
            type="button"
          >
            Not now
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default JGAlertsActivationSheet;
